import {
	ChangeDetectionStrategy,
	ChangeDetectorRef,
	Component,
	ElementRef,
	EventEmitter,
	inject,
	Output,
	ViewChild,
} from "@angular/core";

@Component({
	selector: "ic-tree-view-item",
	templateUrl: "./tree-view-item.component.html",
	styleUrls: ["./tree-view-item.component.scss"],
	changeDetection: ChangeDetectionStrategy.OnPush,
	exportAs: "item",
	standalone: false,
})
export class TreeViewItemComponent {
	private cdRef = inject(ChangeDetectorRef);

	isOpen = false;

	@ViewChild("details", { static: false }) details: ElementRef;

	@Output() detailsToggle = new EventEmitter<boolean>();

	toggleDetails() {
		this.isOpen = !this.isOpen;
		this.detailsToggle.emit(this.isOpen);
		this.cdRef.markForCheck();
	}
}
